export class BonusCalculator
{
    constructor(calculatorContainer)
    {
        if (!(calculatorContainer instanceof HTMLElement)) {
            console.warn('Bonus calculator needs the calculator element to work.');
            return;
        }

        this.calculatorElement = calculatorContainer.querySelector('.wagering-calculator') ?
            calculatorContainer.querySelector('.wagering-calculator') : '';
        this.results = calculatorContainer.querySelector('.results') ?
            calculatorContainer.querySelector('.results') : '';
        this.depositAmount = calculatorContainer.querySelector('.depositAmount') ?
            calculatorContainer.querySelector('.depositAmount') : '';
        this.bonusPercentage = calculatorContainer.querySelector('.bonusPercentage') ?
            calculatorContainer.querySelector('.bonusPercentage') : '';
        if (calculatorContainer.dataset.percentage) {
            this.bonusPercentage = calculatorContainer.dataset.percentage;
        }
        this.maxBonus = calculatorContainer.querySelector('.maxBonus') ?
            calculatorContainer.querySelector('.maxBonus') : '';
        this.wageringMultiplier = calculatorContainer.querySelector('.wageringMultiplier') ?
            calculatorContainer.querySelector('.wageringMultiplier') : '';
        this.bonusType = calculatorContainer.querySelector('.bonusType') ?
            calculatorContainer.querySelector('.bonusType') : '';
        this.gameContributionPercentage = calculatorContainer.querySelector('.gameContributionPercentage') ?
            calculatorContainer.querySelector('.gameContributionPercentage') : '';
        this.timeLimit = calculatorContainer.querySelector('.timeLimit') ?
            calculatorContainer.querySelector('.timeLimit') : '';

        if (!(this.calculatorElement instanceof HTMLElement)
            || !(this.results instanceof HTMLElement)
            || !(this.depositAmount instanceof HTMLElement)
            || !(this.bonusPercentage)
            || !(this.maxBonus instanceof HTMLElement)
            || !(this.wageringMultiplier instanceof HTMLElement)
            || !(this.bonusType instanceof HTMLElement)
            || !(this.gameContributionPercentage instanceof HTMLElement)
            || !(this.timeLimit instanceof HTMLElement)) {
            console.warn('Missing required HTML elements.');
            return;
        }

        let valueGroups = this.calculatorElement.querySelectorAll('.wagering-calculator__value-group');

        for (let valueGroup of valueGroups) {
            let slider = valueGroup.querySelector('.wagering-calculator__slider');
            let bubble = valueGroup.querySelector('.wagering-calculator__bubble-value');
            if (slider && bubble) {
                valueGroup.addEventListener('input', () => {
                    this.setBubble(slider, bubble);
                });
            }
        }

        this.yourDeposit = calculatorContainer.querySelector('.deposit');
        this.bonusAmount = calculatorContainer.querySelector('.bonusAmount');
        this.playerBalance = calculatorContainer.querySelector('.playerBalance');
        this.wageringRequirement = calculatorContainer.querySelector('.wageringRequirement');
        this.effectiveWagering = calculatorContainer.querySelector('.effectiveWagering');
        this.timeLimitDays = calculatorContainer.querySelector('.timeLimitDays');

        this.calculatorElement.addEventListener("change", () => {
            this.updateCalculatorValues();
        });

        this.updateCalculatorValues();
    }

    setBubble(range, bubble)
    {
        bubble.innerHTML = range.value;
    }

    updateCalculatorValues()
    {
        let yourDeposit = parseFloat(this.depositAmount.value ? this.depositAmount.value : 0);
        let bonusPercentage = parseFloat(this.bonusPercentage.value ? this.bonusPercentage.value : this.bonusPercentage);
        let maxBonus = parseFloat(this.maxBonus.value ? this.maxBonus.value : 0);
        let wageringMultiplier = parseFloat(this.wageringMultiplier.value ? this.wageringMultiplier.value : 0);
        let gameContributionPercentage = parseFloat(this.gameContributionPercentage.value ? this.gameContributionPercentage.value : 0);
        let timeLimit = parseFloat(this.timeLimit.value ? this.timeLimit.value : 0);

        if (!yourDeposit || !bonusPercentage) {
            return;
        }

        let bonusAmount = (Math.round(yourDeposit * bonusPercentage) / 100);
        let playerBalance = Math.round(yourDeposit + bonusAmount);
        let playerBalanceMaxBonus = Math.round(yourDeposit + maxBonus);

        this.yourDeposit.innerHTML = Math.round(yourDeposit).toString();
        this.timeLimitDays.innerHTML = Math.round(timeLimit).toString();

        if (maxBonus < bonusAmount && maxBonus > 0) {
            this.bonusAmount.innerHTML = Math.round(maxBonus).toString();
            this.playerBalance.innerHTML = Math.round(playerBalanceMaxBonus).toString();

            if (!this.bonusType.checked) {
                this.wageringRequirement.innerHTML = Math.round(maxBonus * wageringMultiplier).toString();
                this.effectiveWagering.innerHTML = Math.round((maxBonus * wageringMultiplier / gameContributionPercentage) * 100).toString();
            } else {
                this.wageringRequirement.innerHTML = Math.round(playerBalanceMaxBonus * wageringMultiplier).toString();
                this.effectiveWagering.innerHTML = Math.round(((playerBalanceMaxBonus * wageringMultiplier) / gameContributionPercentage) * 100).toString();
            }
        } else {
            this.bonusAmount.innerHTML = Math.round(bonusAmount).toString();
            this.playerBalance.innerHTML = Math.round(playerBalance).toString();

            if (!this.bonusType.checked) {
                this.wageringRequirement.innerHTML = Math.round(bonusAmount * wageringMultiplier).toString();
                this.effectiveWagering.innerHTML = Math.round((bonusAmount * wageringMultiplier / gameContributionPercentage) * 100).toString();
            } else {
                this.wageringRequirement.innerHTML = Math.round(playerBalance * wageringMultiplier).toString();
                this.effectiveWagering.innerHTML = Math.round((playerBalance * wageringMultiplier / gameContributionPercentage) * 100).toString();
            }
        }
    }
}